// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    //c_apiBaseUrl: 'https://development-hss-api.stanglobal.com:5001/api',
   //c_uploadUrl: 'https://development-hss-api.stanglobal.com:5001/api/users/image/',
    c_apiBaseUrl: 'https://api-acc.hartslagsamen.nl/api',
    c_uploadUrl: 'https://api-acc.hartslagsamen.nl/upload/user/',
    c_chatUrl: 'https://chat-acc.hartslagsamen.nl:3000/', // 'https://api-prod.hartslagsamen.nl:3000/', //
    c_hsnUrl: 'https://development-dash-stan.stanglobal.com/',
    c_hssRegisterUrl: 'http://ws-acc-dev.hartslagsamen.nl/aanmelden/',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
